import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.SpacePets;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "SpacePets.Phaser.IntroductionScene.1",
            "SpacePets.Phaser.IntroductionScene.2",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/SpacePets/scenes/GameIntro.ts